module.exports = __webpack_public_path__ + "media/share_images/wave-10dde3f0.svg";